module.exports = __webpack_public_path__ + "static/media/transfers-tooltip.de1aad22.svg";